import { getFactoryState } from "./factory-state";

export class Factory {
    static registerPlugin(pluginKey, pluginClass) {
        Factory._pluginClasses[pluginKey] = pluginClass;
    }
    static getPlugin(pluginKey) {
        return Factory._pluginClasses[pluginKey];
    }
}

Factory._pluginClasses = getFactoryState().pluginClasses;

export { FACTORY_STATE_SYMBOL, getFactoryState } from "./factory-state";

export * from "./factory/index";
//# sourceMappingURL=factory.js.map